module.exports = __webpack_public_path__ + "post-listing-cta-background@2x-3MJmPnx.jpg";